import {FlatList, Image, Text, TouchableOpacity, View} from 'react-native';
import React, {useEffect, useState} from 'react';
import {useAppSelector} from '../../store/hooks';
import {selectPaperPreviewQuestions} from '../../store/xueke';
import {createStyles} from '../../utils/createStyles';
import {
  downloadXkwPapersFileUrl,
  GetXkwPapersPreviewRes,
} from '../../API/mylearn';
import QRCodeModal from '../../components/Url2QRCode';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import Toast from 'react-native-toast-message';

const styles = createStyles({
  paperPreviewBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    paddingLeft: '1.65rem',
    paddingRight: '1.15rem',
    paddingVertical: '1.2rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  paperPreviewBoxWeb: {
    backgroundColor: '#fff',
    flex: 1,
    height: '100%',
    borderRadius: '1rem',
    padding: '1.5rem',
  },
  paperPreviewBoxWebItemImage: {
    width: '80rem',
    height: '120rem',
  },
  paperPreviewBoxBtn: {
    marginLeft: '1.3rem',
    width: '7.25rem',
    height: '23rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  paperPreviewBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperPreviewBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  paperPreviewBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },
});
const PaperPreview = ({route}: any) => {
  console.log('params', route);
  const questions = useAppSelector<GetXkwPapersPreviewRes>(
    selectPaperPreviewQuestions,
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qrcodeValue, setQrcodeValue] = useState('');
  useEffect(() => {
    setQrcodeValue('');
  }, [questions, route]);
  const handleDownLoadFile = async () => {
    showGlobalLoading({text: '下载中'});

    // 最长 60s 倒计时，超时则取消 每 1 秒请求一次 返回值之后停止倒计时
    let count = 0;
    const timer = setInterval(async () => {
      try {
        const p = {
          ...route.params,
        };
        const resaa = await downloadXkwPapersFileUrl(p);
        count++;
        if (count > 60) {
          clearInterval(timer);
        }
        if (resaa.data.status === 2) {
          clearInterval(timer);
          hideGlobalLoading();
          // @ts-ignore
          setQrcodeValue(resaa.data.url);
          setIsModalVisible(true);
        }
        if (resaa.data.status === 3) {
          Toast.show({
            type: 'error',
            text1: '文件下载失败，请稍后重试',
          } as any);
          clearInterval(timer);
          hideGlobalLoading();
        }
        console.log('res', resaa);
      } catch (e) {
        hideGlobalLoading();
        clearInterval(timer);
        console.log(e);
      }
    }, 5000);
  };
  return (
    <View style={styles.paperPreviewBox}>
      <View style={styles.paperPreviewBoxWeb}>
        <FlatList
          style={{flex: 1}}
          data={questions.urls}
          keyExtractor={(item, index) => index + ''}
          ListFooterComponent={() => {
            return (
              <View
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <Text style={{color: '#6F63FF', fontSize: 20}}>
                  -- 线上可预览30%，请下载后查看完整试卷 --
                </Text>
              </View>
            );
          }}
          renderItem={({item}) => {
            return (
              <Image
                resizeMode={'contain'}
                style={styles.paperPreviewBoxWebItemImage}
                source={{uri: item}}
              />
            );
          }}
        />
      </View>
      <TouchableOpacity
        activeOpacity={1}
        onPress={handleDownLoadFile}
        style={styles.paperPreviewBoxBtn}>
        <View style={styles.paperPreviewBoxBtnItem}>
          <Image
            style={styles.paperPreviewBoxBtnItemImg}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_download.png',
            }}
          />
          <Text style={styles.paperPreviewBoxBtnItemText}>下载试题</Text>
        </View>
      </TouchableOpacity>
      <QRCodeModal
        visible={isModalVisible}
        logoImg={
          'https://media.oss.leziedu.com/webapp/classroom/mylearn/logoC.png'
        }
        value={qrcodeValue}
        onClose={() => {
          setIsModalVisible(false);
        }}
      />
    </View>
  );
};

export default PaperPreview;
